import React from 'react';
import CataloguePage from '../Components/Catalogue/CataloguePage';

const Catalogue = () => {
  return <CataloguePage />;
};

export default Catalogue;
